module.exports = __webpack_public_path__ + "img/virtual_controller_color.2282ca73.svg";